export default function isObfuscatedBySpecialChar(code) {
  if (code == null || code.length < 10) return false;

  // All characters except letters, numbers, and spaces
  const nbSpecialChar = (code.match(/[^\w\s]/g) || []).length;

  // All letters, numbers
  const nbAlphanumeric = (code.match(/[A-Za-z0-9]/g) || []).length;

  return nbSpecialChar > nbAlphanumeric;
}
